import gql from "graphql-tag";

export default gql`
  mutation EnableMyShop($input: EnableMyShopMutationInput!) {
    enableMyShop(input: $input) {
      success
    }
  }
`;
